function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,43.921569%,74.901962%)",
      fillOpacity: 1
    },
    d: "M 0.769531 14.460938 C -0.5625 10.558594 -0.277344 6.835938 2.535156 3.648438 C 5.535156 0.246094 9.488281 -0.582031 13.910156 0.363281 C 9.835938 0.0273438 6.351562 1.253906 3.640625 4.21875 C 0.960938 7.140625 0.00390625 10.589844 0.769531 14.460938 Z M 0.769531 14.460938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,43.921569%,74.901962%)",
      fillOpacity: 1
    },
    d: "M 23.421875 9.445312 C 25.800781 16.957031 19.476562 24.375 10.75 22.78125 C 11.761719 22.679688 12.972656 22.679688 14.109375 22.40625 C 15.257812 22.128906 16.40625 21.707031 17.421875 21.125 C 18.457031 20.53125 19.433594 19.761719 20.25 18.90625 C 21.042969 18.070312 21.726562 17.078125 22.226562 16.050781 C 22.742188 15 23.105469 13.839844 23.300781 12.691406 C 23.496094 11.566406 23.398438 10.394531 23.421875 9.445312 Z M 23.421875 9.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,43.921569%,74.901962%)",
      fillOpacity: 1
    },
    d: "M 4.460938 17.582031 C -0.324219 12.929688 1.105469 4.96875 8.007812 2.683594 C 5.394531 4.246094 3.683594 6.445312 2.988281 9.335938 C 2.292969 12.230469 2.769531 14.949219 4.457031 17.582031 Z M 4.460938 17.582031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,43.921569%,74.901962%)",
      fillOpacity: 1
    },
    d: "M 20.023438 6.074219 C 24.390625 11.0625 21.914062 18.269531 16.292969 20.128906 C 21.597656 16.746094 22.480469 10.464844 20.023438 6.074219 Z M 20.023438 6.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,43.921569%,74.901962%)",
      fillOpacity: 1
    },
    d: "M 4.140625 9.363281 C 5.277344 3.867188 10.6875 2.640625 13.785156 4.039062 C 8.570312 3.414062 5.148438 6.59375 4.140625 9.363281 Z M 4.140625 9.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,43.921569%,74.901962%)",
      fillOpacity: 1
    },
    d: "M 19.417969 14.242188 C 18.859375 17.898438 14.191406 20.421875 10.1875 19.023438 C 14.445312 19.292969 17.492188 17.699219 19.417969 14.242188 Z M 19.417969 14.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,43.921569%,74.901962%)",
      fillOpacity: 1
    },
    d: "M 11.960938 14.886719 C 13.898438 14.886719 15.464844 13.371094 15.464844 11.5 C 15.464844 9.628906 13.898438 8.109375 11.960938 8.109375 C 10.027344 8.109375 8.457031 9.628906 8.457031 11.5 C 8.457031 13.371094 10.027344 14.886719 11.960938 14.886719 Z M 11.960938 14.886719 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulser);
export default __webpack_public_path__ + "static/media/pulser.7541fd9d32672629276976deb34c083c.svg";
export { ForwardRef as ReactComponent };